import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const Container = ({ className, fluid, small, large, ...props }) => {
  const { children } = props;
  const classes = classNames('Container', className, {
    container: !fluid,
    'container--small': small,
    'container--large': large,
    'container--fluid': fluid,
  });
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

Container.defaultProps = {
  small: false,
  large: false,
  fluid: false,
};

Container.propTypes = {
  small: PropTypes.bool,
  large: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Container;
